import React, { useState } from 'react';
import api from '../services/api';

function time(value) { return value ? new Date(value).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : ''; }
export function ConversationMessage({ message, raw = false }) {
    const [expanded, setExpanded] = useState(false);
    const legacyLong = !raw && message.role === 'assistant' && message.kind === 'reply' && !message.audience && message.text?.length > 500;
    const head = String(message.text || '').slice(0, 320);
    const boundary = head.lastIndexOf('. ');
    const preview = head.slice(0, boundary > 100 ? boundary + 1 : (head.lastIndexOf(' ') > 100 ? head.lastIndexOf(' ') : head.length));
    const author = message.role === 'user' ? (message.source === 'terminal_help_button' ? 'Терминал' : 'Сотрудник ТП') : 'Hermes';
    return <article className={`tc-message ${message.role}`}>
        <div className="tc-message-meta"><b>{author}</b><time>{time(message.at)}</time>{message.kind === 'daily_review' ? <span>Проверка логов за сутки</span> : null}</div>
        <p>{legacyLong && !expanded ? preview + '…' : message.text}</p>
        {legacyLong ? <button className="tc-message-more" onClick={() => setExpanded(value => !value)} aria-expanded={expanded}>{expanded ? 'Свернуть' : 'Показать полностью'}</button> : null}
        {message.logReview ? <small className="tc-log-coverage">Окно: {message.logReview.windowHours} ч · прочитано {Math.round(message.logReview.bytesRead / 1024)} КБ{message.logReview.truncated ? ' · выборка ограничена объёмом' : ''}</small> : null}
    </article>;
}
export function DiagnosticJournal({ terminal, journal }) {
    const [older, setOlder] = useState([]), [cursor, setCursor] = useState(null), [hasMore, setHasMore] = useState(null), [loading, setLoading] = useState(false), [error, setError] = useState('');
    const messages = [...older, ...(journal?.messages || [])].filter((m, i, all) => all.findIndex(n => n.id === m.id) === i);
    async function previous() {
        if (loading) return;
        setLoading(true); setError('');
        try {
            const { data } = await api.get(`/api/v2/terminal-diagnostics/${terminal}/chat`, { params: { before: cursor ?? journal?.nextBefore } });
            if (!data.journal) throw new Error('JOURNAL_UNAVAILABLE');
            setOlder(value => [...data.journal.messages, ...value]); setCursor(data.journal.nextBefore); setHasMore(data.journal.hasMore);
        } catch { setError('Не удалось загрузить журнал. Попробуйте ещё раз.'); }
        finally { setLoading(false); }
    }
    return <details className="tc-journal">
        <summary>Журнал диагностики</summary>
        <p className="tc-journal-note">Команды, промежуточные результаты и полная история проверок.</p>
        <div className="tc-journal-log" aria-label="Журнал диагностики терминала">
            {(hasMore ?? journal?.hasMore) ? <button className="tc-history-button" onClick={previous} disabled={loading}>{loading ? 'Загружаем…' : 'Ранее в журнале'}</button> : null}
            {error ? <p className="tc-error" role="alert">{error}</p> : null}
            {!messages.length ? <p className="tc-journal-note">Записей пока нет.</p> : messages.map(message => <ConversationMessage key={message.id} message={message} raw/>)}
        </div>
    </details>;
}
